import { render, staticRenderFns } from "./pay-channel-cost.vue?vue&type=template&id=db455d80&scoped=true&"
import script from "./pay-channel-cost.vue?vue&type=script&lang=js&"
export * from "./pay-channel-cost.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel-cost.vue?vue&type=style&index=0&id=db455d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db455d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db455d80')) {
      api.createRecord('db455d80', component.options)
    } else {
      api.reload('db455d80', component.options)
    }
    module.hot.accept("./pay-channel-cost.vue?vue&type=template&id=db455d80&scoped=true&", function () {
      api.rerender('db455d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-channel-management/pay-channel-cost.vue"
export default component.exports